<app-mini-layout-wrapper [showLogout]="true">
  <div class="mini-layout__title">{{ pageTexts.title }}</div>
  <div class="mini-layout__text">{{ pageTexts.subtitle }}</div>

  <app-step-box [activeStep]="activeStep" [stepNumber]="1" [stepTexts]="pageTexts.step1.step" design="activation"
                (activeClick)="openLicenseCodeDialog()" (visitedClick)="openLicenseCodePopup()">
  </app-step-box>

  <app-step-box [activeStep]="activeStep" [stepNumber]="2" [stepTexts]="pageTexts.step2.step" design="activation"
                (activeClick)="openCertificateDialog()" (visitedClick)="openCertificateDialog()">
  </app-step-box>

  <app-step-box [activeStep]="activeStep" [stepNumber]="3" [stepTexts]="pageTexts.step3.step" design="activation"
                (activeClick)="openActivationCodeDialog()">
  </app-step-box>
</app-mini-layout-wrapper>
